<div class="bk-page sb">
  <header class="bk-page__head sb__head">
    <div class="bk-page__intro">
      <app-back-button class="sb__back" label="Segments" (back)="backToSegments()" />
      <p class="bk-eyebrow">Segment</p>
      @if (ready) {
        <h1 class="bk-page__title">{{ segmentName || 'Untitled segment' }}</h1>
      } @else if (loadError) {
        <h1 class="bk-page__title">Segment did not load</h1>
      } @else {
        <span class="bk-skel sb__skel-title" aria-hidden="true"></span>
      }
      <p class="bk-page__sub">{{ description }}</p>
    </div>
  </header>

  <alternative-stepper class="sb__steps" [steps]="steps" [noContent]="true" />

  <div class="sb__body">
    @if (loadError) {
      <section class="bk-panel sb__state" role="alert">
        <p class="sb__state-text">{{ loadError }}</p>
        <button type="button" class="bk-btn bk-btn--ghost" (click)="loadSegment()">Load again</button>
      </section>
    } @else if (!ready) {
      <span class="bk-skel sb__skel" aria-hidden="true"></span>
      <span class="bk-sr-only" role="status">Loading the segment</span>
    } @else {
      @switch (searchQuery) {
        @case ('review') {
          <segment-review />
        }
        @case ('rule') {
          <segment-rule />
        }
        @default {
          <segment-information />
        }
      }
    }
  </div>
</div>
